module.exports = __webpack_public_path__ + "img/estimate_letter_grey.6a10b0ea.svg";